import { useJurisdictionsQuery } from 'queries/wage/useJurisdictionsQuery'

type Jurisdiction = NonNullable<
  ReturnType<typeof useJurisdictionsQuery>['data']
>[number]

export const formatJurisdictionOptionLabel = (j: Jurisdiction): string => {
  const parts = [j.name]
  if (j.stateCode) parts.push(j.stateCode.toUpperCase())
  parts.push(j.level)
  parts.push(`#${j.id}`)
  return parts.join(' · ')
}
